const Sites = { name: "Catalogo", urls: ["/","/catalogo", "/catalogo-details/:productId"] }

export default Sites